import Vue from 'vue';
import { on } from '../utils/dom/event';
var MIN_DISTANCE = 5;

function getScaleDistance(touches) {
  return Math.sqrt(Math.pow(touches[0].clientX - touches[1].clientX, 2) + Math.pow(touches[0].clientY - touches[1].clientY, 2));
}

function getDirection(x, y) {
  if (x > y && x > MIN_DISTANCE) {
    return 'horizontal';
  }

  if (y > x && y > MIN_DISTANCE) {
    return 'vertical';
  }

  return '';
}

export var TouchMixin = Vue.extend({
  data: function data() {
    return {
      direction: ''
    };
  },
  methods: {
    touchStart: function touchStart(event) {
      this.resetTouchStatus();
      this.startX = event.touches[0].clientX;
      this.startY = event.touches[0].clientY;
      this.timeStamp = event.timeStamp;

      if (event.touches.length === 2) {
        this.startScaleDistance = getScaleDistance(event.touches);
      }
    },
    touchMove: function touchMove(event) {
      var timeStamp = event.timeStamp;
      var touch = event.touches[0];
      var lastDeltaX = this.deltaX,
          lastDeltaY = this.deltaY,
          lastTimeStamp = this.timeStamp;
      this.deltaX = touch.clientX - this.startX;
      this.deltaY = touch.clientY - this.startY;
      this.offsetX = Math.abs(this.deltaX);
      this.offsetY = Math.abs(this.deltaY);
      this.timeStamp = timeStamp;
      var time = timeStamp - lastTimeStamp;
      this.speedX = (this.deltaX - lastDeltaX) / time;
      this.speedY = (this.deltaY - lastDeltaY) / time;

      if (event.touches.length > 1) {
        this.scaleDistance = getScaleDistance(event.touches);
      }

      this.direction = this.direction || getDirection(this.offsetX, this.offsetY);
    },
    resetTouchStatus: function resetTouchStatus() {
      this.direction = '';
      this.deltaX = 0;
      this.deltaY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
      this.startScaleDistance = 0;
      this.scaleDistance = 0;
      this.timeStamp = 0;
      this.speedX = 0;
      this.speedY = 0;
    },
    // avoid Vue 2.6 event bubble issues by manually binding events
    // https://github.com/youzan/vant/issues/3015
    bindTouchEvent: function bindTouchEvent(el) {
      var onTouchStart = this.onTouchStart,
          onTouchMove = this.onTouchMove,
          onTouchEnd = this.onTouchEnd;
      on(el, 'touchstart', onTouchStart);
      on(el, 'touchmove', onTouchMove);

      if (onTouchEnd) {
        on(el, 'touchend', onTouchEnd);
        on(el, 'touchcancel', onTouchEnd);
      }
    }
  }
});